const EMPTY = 'Empty';
const PEASANT = 'Peasant';
const ASSASSIN = 'Assassin';
const KNIGHT = 'Knight';
const CAVALRY = 'Cavalry';
const MAGE = 'Mage';
const HERO = 'Hero';
const KING = 'King';
const UNTURNED = 'Unturned';

export const PIECE_NAMES = {
    EMPTY,
    PEASANT,
    ASSASSIN,
    KNIGHT,
    CAVALRY,
    MAGE,
    HERO,
    KING,
    UNTURNED,
};

export const PIECE_VALUES = {
    [EMPTY]: 0,
    [PEASANT]: 1,
    [ASSASSIN]: 2,
    [KNIGHT]: 3,
    [CAVALRY]: 4,
    [MAGE]: 5,
    [HERO]: 6,
    [KING]: 7,
    [UNTURNED]: 8,
};

export const PIECE_VALUE_NAMES = {
    [PIECE_VALUES.Empty]: PIECE_NAMES.EMPTY,
    [PIECE_VALUES.Peasant]: PIECE_NAMES.PEASANT,
    [PIECE_VALUES.Assassin]: PIECE_NAMES.ASSASSIN,
    [PIECE_VALUES.Knight]: PIECE_NAMES.KNIGHT,
    [PIECE_VALUES.Cavalry]: PIECE_NAMES.CAVALRY,
    [PIECE_VALUES.Mage]: PIECE_NAMES.MAGE,
    [PIECE_VALUES.Hero]: PIECE_NAMES.HERO,
    [PIECE_VALUES.King]: PIECE_NAMES.KING,
    [PIECE_VALUES.Unturned]: PIECE_NAMES.UNTURNED,
};

export const PIECES = {
    [EMPTY]: {
        name: EMPTY,
        value: PIECE_VALUES.Empty,
    },
    [PEASANT]: {
        name: PEASANT,
        value: PIECE_VALUES.Peasant,
    },
    [ASSASSIN]: {
        name: ASSASSIN,
        value: PIECE_VALUES.Assassin,
    },
    [KNIGHT]: {
        name: KNIGHT,
        value: PIECE_VALUES.Knight,
    },
    [CAVALRY]: {
        name: CAVALRY,
        value: PIECE_VALUES.Cavalry,
    },
    [MAGE]: {
        name: MAGE,
        value: PIECE_VALUES.Mage,
    },
    [HERO]: {
        name: HERO,
        value: PIECE_VALUES.Hero,
    },
    [KING]: {
        name: KING,
        value: PIECE_VALUES.King,
    },
    [UNTURNED]: {
        name: UNTURNED,
        value: PIECE_VALUES.Unturned,
    },
};

export const STANDARD_PLAYER_PIECE_MAP = {
    [PIECE_NAMES.PEASANT]: 5,
    [PIECE_NAMES.ASSASSIN]: 2,
    [PIECE_NAMES.KNIGHT]: 2,
    [PIECE_NAMES.CAVALRY]: 2,
    [PIECE_NAMES.MAGE]: 2,
    [PIECE_NAMES.HERO]: 2,
    [PIECE_NAMES.KING]: 1,
};

export const PIECES_BY_VALUE = {
    [PIECE_VALUES.Empty]: PIECES.Empty,
    [PIECE_VALUES.Peasant]: PIECES.Peasant,
    [PIECE_VALUES.Assassin]: PIECES.Assassin,
    [PIECE_VALUES.Knight]: PIECES.Knight,
    [PIECE_VALUES.Cavalry]: PIECES.Cavalry,
    [PIECE_VALUES.Mage]: PIECES.Mage,
    [PIECE_VALUES.Hero]: PIECES.Hero,
    [PIECE_VALUES.King]: PIECES.King,
    [PIECE_VALUES.Unturned]: PIECES.Unturned,
};
